
import * as Yup from "yup";

export const initialValues = (fields) => {


    const initialValues = {};
    const keys = Object.keys(fields);
    const values = Object.values(fields);
    for (let i = 0; i < keys.length; i += 1) {
        if('value' in values[i]){
            initialValues[keys[i]] = values[i].value;
        }
        else{
            initialValues[keys[i]] = ('default' in values[i] ? values[i].default : '');
        }
    }
    return initialValues;
}

export const getValidationFromFields = (fields) => {
    
    const keys = Object.keys(fields);
    const values = Object.values(fields);
    const validation = {};
    for (let i = 0; i < keys.length; i += 1) {
        const field = values[i];
        const key = keys[i];
        let required = false;
        if(!('required' in field)){
            required = true;
        }
        else{
            required = field.required;
        }
        if(required){
            validation[key] = Yup.string().required('Required')
        }
    }
    const validationSchema = Yup.object().shape(validation);
    return validationSchema;
}
